<template>
  <li class="dropdown notification-list">
    <a
      class="nav-link dropdown-toggle arrow-none text-decoration-none"
      href="#"
      @click.prevent="toggleNotificationDropDown"
    >
      <i class="mdi mdi-bell-outline noti-icon font-24"></i>
      <span class="noti-icon-text-badge" v-show="unseen_notification_count > 0">
        <template v-if="unseen_notification_count > 99">99+</template>
        <template v-else>{{ unseen_notification_count }}</template>
      </span>
    </a>
    <dropdown item-class="dropdown-lg" :show="showContainer">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <h5 class="m-0">
          <span class="float-end" v-show="unread_notifications.length">
            <a href="javascript: void(0);" class="text-dark" @click="markAsReadNotifications()">
              <small>{{ $t('views.layouts.delete_all') }}</small>
            </a> </span
          >{{ $t('views.layouts.notification') }}
        </h5>
      </div>

      <div class="slimScrollDiv">
        <!-- item-->
        <template v-if="filteredNotifications.length">
          <div class="slimscroll">
            <a
              :href="notification.data.url"
              class="dropdown-item notify-item"
              :class="{ 'cursor-pointer': notification.data.url?.length > 0 }"
              target="_blank"
              v-for="notification in filteredNotifications"
              :key="notification.id"
            >
              <div class="notify-icon bg-primary">
                <i class="mdi" :class="getIcon(notification.type)"></i>
              </div>
              <p class="notify-details">
                <span>
                  <span
                    v-if="displayContent(notification.data.message).type === 'html'"
                    v-html="displayContent(notification.data.message).content"
                  ></span>
                  <template v-else>
                    <i18n-t :keypath="notification.data.message" tag="span" />
                  </template>
                </span>
                <small class="text-muted">
                  {{ $filters.humanReadable(notification.created_at) }}
                </small>
              </p>
            </a>
          </div>
        </template>

        <div v-else class="dropdown-item notify-item">
          <p>{{ $t('views.layouts.no_new_notification') }}</p>
        </div>
      </div>
      <!-- All-->
    </dropdown>
  </li>
</template>

<script>
import { storeToRefs } from 'pinia'

import { event } from 'vue-gtag'

import { useAdminAuthStore } from '@/stores/admin/auth.js'
import { displayHTMLContent } from '@/utilities/helpers.js'

import Dropdown from '@/components/Dropdown.vue'

export default {
  components: {
    Dropdown
  },
  setup() {
    const adminAuthStore = useAdminAuthStore()
    const { unread_notifications, user, unseen_notification_count } = storeToRefs(adminAuthStore)

    return {
      unread_notifications,
      user,
      unseen_notification_count,
      adminAuthStore
    }
  },
  data() {
    return {
      showNotificationContainer: false,
      filteredNotifications: []
    }
  },
  beforeUnmount() {
    window.removeEventListener('click', this.close)
  },
  methods: {
    displayContent(message) {
      return displayHTMLContent(message)
    },
    toggleNotificationDropDown() {
      this.showNotificationContainer = !this.showNotificationContainer

      if (this.unseen_notification_count > 0) {
        this.adminAuthStore.markAsSeenNotifications()
      }

      event('page_actions', {
        event_action: 'notification_opened'
      })
    },
    getFilename(name) {
      return import.meta.env.VITE_BACKEND_URL + name
    },
    getNotificationType(type) {
      return type ? type.split('\\').pop() : ''
    },
    getIcon(type) {
      const notificationType = this.getNotificationType(type)
      if (notificationType === 'ExportReady') {
        return 'mdi-paperclip'
      } else {
        return 'mdi-bell'
      }
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.showNotificationContainer = false
      }
    },
    getNotifications() {
      this.adminAuthStore.getNotifications()
    },
    markAsReadNotifications() {
      this.adminAuthStore.markAsReadNotifications()
    }
  },
  created() {
    this.getNotifications()
    window.addEventListener('click', this.close)

    this.filteredNotifications = this.unread_notifications.filter(notification =>
      Object.hasOwn(notification, 'message')
    )
  },
  computed: {
    showContainer() {
      return this.showNotificationContainer ? 'show' : ''
    }
  }
}
</script>

<style scoped>
.slimScrollDiv {
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}
</style>
